import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, change} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {required, SelectInput} from 'admin-on-rest';
import DbasWithIdsSelectInput from './DbasWithIdsSelectInput';
import LocationsWithIdsSelectInput from './LocationsWithIdsSelectInput';
import DiscountConditionTableRow from '../components/DiscountConditionTableRow';
import ReactTooltip from 'react-tooltip';
import TooltipIcon from './TooltipIcon';
import {viewStyles} from '../shared/styles-view';
import RaisedButton from 'material-ui/RaisedButton';
import IconAdd from 'material-ui/svg-icons/content/add';
import {Card, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';

/**
 * A component for adding and removing DBA and Location Conditions
 *
 */
class DiscountConditionTables extends Component {
    constructor(props) {
        super(props);
        const addedDbaValues = props.addedDbaValues;
        const addedLocationValues = props.addedLocationValues;
        const dbaLength = addedDbaValues.length;
        const locationLength = addedLocationValues.length;

        this.state = {
            dbaInclude: (dbaLength > 0) ? addedDbaValues[0].comparison : null,
            dbaList: (addedDbaValues) ? addedDbaValues : [],
            locationInclude: (locationLength > 0) ? addedLocationValues[0].comparison : null,
            locationList: (addedLocationValues) ? addedLocationValues : [],
            selectedDba: {
                display_name: null,
                id: null,
                name: null
            },
            selectedLocation: {
                display_name: null,
                id: null,
                name: null
            },
            showAdd: !!(addedDbaValues > 0 || locationLength > 0),
            isOverridden: !!(addedDbaValues || addedLocationValues)
        };
    }

    componentDidMount() {
        if (this.state.isOverridden) {
            this.updateConditions();
        }
    }

    /**
     * Display or Hide Add form
     *
     * @param e
     * @param doDisplay
     */
    handleDisplayAddForm = (e, doDisplay) => {
        this.setState({
            displayType: null,
            selectedDba: {
                display_name: null,
                id: null,
                name: null
            },
            selectedLocation: {
                display_name: null,
                id: null,
                name: null
            },
            showAdd: doDisplay
        });
    };

    /**
     * Process event for selecting a DBA
     *
     * @param e
     * @param source
     * @param id
     * @param name
     */
    handleSelectDba = (e, source, id, name) => {
        const item = {
            display_name: id + ' - ' + name,
            id: id,
            name: name
        };
        this.setState({
            selectedDba: item
        });
    };

    /**
     * Process event for selecting a Location
     *
     * @param e
     * @param source
     * @param id
     * @param name
     */
    handleSelectLocation = (e, source, id, name) => {
        const item = {
            display_name: id + ' - ' + name,
            id: id,
            name: name
        };
        this.setState({
            selectedLocation: item
        })
    };

    /**
     * Process event for adding a DBA
     */
    handleAddDba = () => {
        let dba = this.state.selectedDba;
        if (dba.id && this.state.dbaList.findIndex(i => i.id === dba.id) === -1) {
            let list = JSON.parse(JSON.stringify(this.state.dbaList));
            list.push(this.state.selectedDba);
            this.setState({
                dbaList: list,
                selectedDba: {
                    display_name: null,
                    id: null,
                    name: null
                }
            }, () => {
                this.props.dispatch(change('record-form', 'add_condition_dba', null));
                this.updateConditions();
            });
        }
    };

    /**
     * Process event for adding a Location
     */
    handleAddLocation = () => {
        let location = this.state.selectedLocation;
        if (location.id && this.state.locationList.findIndex(i => i.id === location.id) === -1) {
            let list = JSON.parse(JSON.stringify(this.state.locationList));
            list.push(this.state.selectedLocation);
            this.setState({
                locationList: list,
                selectedLocation: {
                    display_name: null,
                    id: null,
                    name: null
                }
            }, () => {
                this.props.dispatch(change('record-form', 'add_condition_location', null));
                this.updateConditions();
            });
        }
    };

    /**
     * Process event for removing a row
     *
     * @param type
     * @param item
     */
    handleRemoveItem = (type, item) => {
        let list;
        if (type === 'dba') {
            list = JSON.parse(JSON.stringify(this.state.dbaList));
        }
        if (type === 'location') {
            list = JSON.parse(JSON.stringify(this.state.locationList));
        }
        let updatedList = this.removeItemFromList(list, item, 'id');

        // Remove the item from the added list
        if (type === 'dba') {
            this.setState({
                dbaList: updatedList,
                selectedDba: {
                    display_name: null,
                    id: null,
                    name: null
                }
            }, () => {
                this.updateConditions();
            });
        }
        if (type === 'location') {
            this.setState({
                locationList: updatedList,
                selectedLocation: {
                    display_name: null,
                    id: null,
                    name: null
                }
            }, () => {
                this.updateConditions();
            });
        }
    };

    // Remove an item from an array
    removeItemFromList = (array, value, attribute) => {
        return array.filter(e => e[attribute].toString() !== value.toString());
    };

    /**
     * Set equals/notequals for DBAs
     *
     * @param event
     * @param value
     */
    handleSetDbaInclude = (event, value) => {
        if (value) {
            this.setState({
                dbaInclude: value
            }, () => {
                this.updateConditions();
            });
        }
    };

    /**
     * Set equals/notequals for Locations
     *
     * @param event
     * @param value
     */
    handleSetLocationInclude = (event, value) => {
        if (value) {
            this.setState({
                locationInclude: value
            }, () => {
                this.updateConditions();
            });
        }
    };

    /**
     * Lift state to update Discount Conditions
     */
    updateConditions = () => {
        this.props.onConditionUpdate(this.state.dbaList, this.state.locationList, this.state.dbaInclude, this.state.locationInclude);
    };

    /**
     * Generate a table of added items
     *
     * @param type
     * @param list
     * @param removeClickFunc
     * @return {*}
     */
    makeConditionsTable = (type, list, removeClickFunc) => {
        let typeName = (type === 'dba') ? 'DBA' : 'Location';
        if (!list || list.length === 0) {
            return (
                <TableRow>
                    <TableRowColumn colSpan={2}>No {typeName} Items</TableRowColumn>
                    <TableRowColumn>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        return (
            list.map((item, index) => (
                <DiscountConditionTableRow
                    key={item.id.toString() + index.toString()}
                    id={item.id.toString()}
                    name={item.name.toString()}
                    type={type}
                    onRemoveClick={removeClickFunc}
                />
            ))
        )
    };

    render() {
        const {
            buyQty,
            getQty,
            type
        } = this.props;

        const {
            dbaList,
            locationList,
            selectedDba,
            selectedLocation,
            showAdd
        } = this.state;

        // Display or hide form
        const addStyle = (showAdd) ? {} : viewStyles.hidden;

        return (
            <div>
                {type && buyQty && getQty &&
                    <Card>
                        <CardText>
                        <span style={{...viewStyles.fieldHeader, ...viewStyles.noMargin}}>
                            Restrict by a DBA or Location
                            <TooltipIcon dataFor="ttConditionTable"/>
                            <ReactTooltip id="ttConditionTable" type="light" effect="solid" multiline={true}
                                          border={true}
                                          className="tooltip">
                                Some Discounts are only valid at specific Locations or for specific DBAs, or
                                everywhere except at specific Locations or DBAs. Add DBAs or Locations to restrict
                                this Discount's availability.
                            </ReactTooltip>
                        </span>
                            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                            <p style={viewStyles.fieldParagraph}>
                                If this BXGY Discount is only valid at specific Locations or for specific DBAs, or is
                                valid everywhere <em>except</em> at specific Locations or DBAs, add them here. To remove
                                a DBA or Location, click its <em>Remove</em> icon.
                                <br/><br/>
                                If DBAs are added, you must select Validity for all DBAs.
                                <br/>
                                If Locations are added, you must select Validity for all Locations.
                            </p>

                            <div style={addStyle}>

                                <span style={viewStyles.fieldHeader}>DBAs</span>
                                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                                {/* DBAs Table */}
                                <Table selectable={false} multiSelectable={false}>
                                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                        <TableRow>
                                            <TableHeaderColumn><span>ID</span></TableHeaderColumn>
                                            <TableHeaderColumn><span>Name</span></TableHeaderColumn>
                                            <TableHeaderColumn><span>Remove</span></TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody displayRowCheckbox={false}>
                                        {[...this.makeConditionsTable('dba', dbaList, this.handleRemoveItem)]}
                                    </TableBody>
                                </Table>
                                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                                {/* Select DBA to Add */}
                                <Field name="add_condition_dba"
                                       component={DbasWithIdsSelectInput}
                                       formName="record-form"
                                       label="Select a DBA"
                                       source="add_condition_dba"
                                       onSelectChange={this.handleSelectDba}
                                />
                                {selectedDba.id &&
                                    <RaisedButton
                                        primary
                                        label="Add selected DBA"
                                        icon={<IconAdd/>}
                                        onClick={this.handleAddDba}
                                    />
                                }
                                <hr style={viewStyles.break}/>

                                {/* Select Validity of DBA selections */}
                                {dbaList.length > 0 &&
                                    <Field name="add_condition_dba_include"
                                           component={SelectInput}
                                           choices={[
                                               {id: 'equals', name: 'Discount is valid ONLY for selected DBAs'},
                                               {
                                                   id: 'notequals',
                                                   name: 'Discount is valid everywhere EXCEPT selected DBAs'
                                               }
                                           ]}
                                           label="Set DBA Validity"
                                           onChange={this.handleSetDbaInclude}
                                           validate={[required]}
                                           style={viewStyles.rowShowFieldWide}
                                    />
                                }

                                <span style={viewStyles.fieldHeader}>Locations</span>
                                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                                {/* Locations Table */}
                                <Table selectable={false} multiSelectable={false}>
                                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                        <TableRow>
                                            <TableHeaderColumn><span>ID</span></TableHeaderColumn>
                                            <TableHeaderColumn><span>Name</span></TableHeaderColumn>
                                            <TableHeaderColumn><span>Remove</span></TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody displayRowCheckbox={false}>
                                        {[...this.makeConditionsTable('location', locationList, this.handleRemoveItem)]}
                                    </TableBody>
                                </Table>
                                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                                {/* Select Location to Add */}
                                <Field name="add_condition_location"
                                       component={LocationsWithIdsSelectInput}
                                       formName="record-form"
                                       label="Select a Location"
                                       source="add_condition_location"
                                       onSelectChange={this.handleSelectLocation}
                                />
                                {selectedLocation.id &&
                                    <RaisedButton
                                        primary
                                        label="Add selected Location"
                                        icon={<IconAdd/>}
                                        onClick={this.handleAddLocation}
                                    />
                                }
                                <hr style={viewStyles.break}/>

                                {/* Select Validity of Location selections */}
                                {locationList.length > 0 &&
                                    <Field name="add_condition_location_include"
                                           component={SelectInput}
                                           choices={[
                                               {id: 'equals', name: 'Discount is valid ONLY at selected Locations'},
                                               {
                                                   id: 'notequals',
                                                   name: 'Discount is valid everywhere EXCEPT selected Locations'
                                               }
                                           ]}
                                           label="Set Location Validity"
                                           onChange={this.handleSetLocationInclude}
                                           validate={[required]}
                                           style={viewStyles.rowShowFieldWide}
                                    />
                                }
                            </div>

                            {/* Add DBA or Location */}

                            {!showAdd &&
                                <div>
                            <span style={{...viewStyles.fieldHeader, ...viewStyles.paddingBottom}}>
                                DBAs and Locations
                            </span>
                                    <RaisedButton
                                        primary
                                        label="Add a DBA or Location"
                                        icon={<IconAdd/>}
                                        onClick={(e) => this.handleDisplayAddForm(e, true)}
                                        style={viewStyles.rowShowField}
                                    />
                                </div>
                            }

                        </CardText>
                    </Card>
                }
                <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        const addedDbaValues = (form.values['dba_values']) ? form.values['dba_values'] : [];
        const addedLocationValues = (form.values['location_values']) ? form.values['location_values'] : [];
        return {
            addedDbaValues: addedDbaValues,
            addedLocationValues: addedLocationValues
        }
    }
    return {}
}

DiscountConditionTables.propTypes = {
    addField: PropTypes.bool,
    buyQty: PropTypes.number,
    getQty: PropTypes.number,
    onConditionUpdate: PropTypes.func,
    type: PropTypes.string,
};

DiscountConditionTables.defaultProps = {
    addField: true,
    buyQty: 0,
    getQty: 0,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(DiscountConditionTables);



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountConditionTables.js